export default __webpack_public_path__ + "static/media/first-layer.e0b3ccb0.svg";